var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.pieSeries,"min-height":"280px","max-height":"300px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }